// src/js/config/pricingCalculator.js

import { DOMElements } from './dom.js';
import { DependencyManager } from './dependencyManager.js';
import { formatter } from '../utils/helpers.js';

// TODO: Refaktorera data-hämtningen så att den importeras istället för att vara global.

export const PricingCalculator = (function() {
    let currentCheapestTier = '';
    let currentTierSummaries = {};

    function updatePrices() {
        const { pricingTable, pricingTableRows } = DOMElements;
        if (!pricingTable) {
            console.error("Pricing table not found.");
            return;
        }

        const basePrices = window.SimP?.DATA?.basePrices || {};
        const addonPrices = window.SimP?.DATA?.addonPrices || {};
        const addonPricesPerUnit = window.SimP?.DATA?.addonPricesPerUnit || {};
        const TIERS = Object.keys(basePrices);
        
        if (TIERS.length === 0) {
            console.warn("Pricing data (basePrices) not found on window.SimP.DATA. Cannot calculate prices.");
            return;
        }

        DependencyManager.evaluateDependencies();

        const addonSums = TIERS.reduce((acc, tier) => ({ ...acc, [tier]: 0 }), {});

        pricingTableRows.forEach(row => {
            const type = row.dataset.type;
            const featureId = row.dataset.featureId;

            if (type === "single") {
                const checkbox = row.querySelector("input[type='checkbox']");
                if (checkbox && checkbox.checked) {
                    const price = addonPrices[featureId] || 0;
                    TIERS.forEach(tier => {
                        const cell = row.querySelector(`[data-category='${tier}']`);
                        if (cell && cell.textContent.trim() !== "✔") {
                            addonSums[tier] += price;
                        }
                    });
                }
            } else if (type === "multi") {
                const qty = parseFloat(row.querySelector("input[type='number']").value) || 0;
                const unitPrice = addonPricesPerUnit[featureId] || 0;
                TIERS.forEach(tier => {
                    const included = parseFloat(row.getAttribute(`data-included${tier.toLowerCase()}`)) || 0;
                    const extraUnits = Math.max(0, qty - included);
                    addonSums[tier] += extraUnits * unitPrice;
                });
            }
        });
        
        const allCategoryTotals = {};
        TIERS.forEach(tier => {
            const total = (basePrices[tier] || 0) + addonSums[tier];
            allCategoryTotals[tier] = total;
            currentTierSummaries[tier] = {
                packagePrice: basePrices[tier] || 0,
                currentAddonPrice: addonSums[tier],
                totalPrice: total
            };
        });

        currentCheapestTier = Object.keys(allCategoryTotals).reduce((a, b) =>
            allCategoryTotals[a] < allCategoryTotals[b] ? a : b
        , TIERS[0] || '');

        pricingTable.querySelectorAll(".highlight").forEach(el => el.classList.remove("highlight"));
        
        TIERS.forEach(tier => {
            const summary = currentTierSummaries[tier];
            const baseCell = pricingTable.querySelector(`.base[data-category='${tier}']`);
            const addonsCell = pricingTable.querySelector(`.addons[data-category='${tier}']`);
            const totalCell = pricingTable.querySelector(`.total[data-category='${tier}']`);

            if(baseCell) baseCell.textContent = formatter.format(summary.packagePrice);
            if(addonsCell) addonsCell.textContent = formatter.format(summary.currentAddonPrice);
            if(totalCell) totalCell.textContent = formatter.format(summary.totalPrice);

            if (tier === currentCheapestTier) {
                if(baseCell) baseCell.classList.add("highlight");
                if(addonsCell) addonsCell.classList.add("highlight");
                if(totalCell) totalCell.classList.add("highlight");
            }
        });

        pricingTableRows.forEach(row => {
            const type = row.dataset.type;
            const featureId = row.dataset.featureId;
            const perUnitCell = row.querySelector(".per-unit");
            const addonCell = row.querySelector(".addon-price");
            const tierCell = row.querySelector(`[data-category='${currentCheapestTier}']`);

            if (type === "single") {
                const checkbox = row.querySelector("input[type='checkbox']");
                if (addonCell) {
                    const price = addonPrices[featureId] || 0;
                    addonCell.textContent = formatter.format(price);
                }
                
                // ### KORRIGERING BÖRJAR HÄR ###
                if (checkbox && checkbox.checked) {
                    if (tierCell && tierCell.textContent.trim() === "✔") {
                        tierCell.classList.add("highlight");
                    } else if (addonCell) {
                        addonCell.classList.add("highlight");
                    }
                } else {
                    // TILLAGD: Denna saknade else-sats ser till att hela kolumnen
                    // för det billigaste paketet alltid markeras korrekt.
                    if (tierCell) {
                        tierCell.classList.add("highlight");
                    }
                }
                // ### KORRIGERING SLUTAR HÄR ###

            } else if (type === "multi") {
                const qty = parseFloat(row.querySelector("input[type='number']").value) || 0;
                const unitPrice = addonPricesPerUnit[featureId] || 0;
                const included = parseFloat(row.getAttribute(`data-included${currentCheapestTier.toLowerCase()}`)) || 0;

                if (addonCell) {
                    const extra = Math.max(0, qty - included);
                    addonCell.textContent = formatter.format(extra * unitPrice);
                }
                
                if (perUnitCell) {
                    perUnitCell.textContent = unitPrice > 0 ? formatter.format(unitPrice) : '';
                }

                if (qty <= included) {
                    if (tierCell) tierCell.classList.add("highlight");
                } else {
                    if (addonCell) addonCell.classList.add("highlight");
                }
            }
        });
    }

    return {
        updatePrices: updatePrices,
        getCurrentCheapestTier: () => currentCheapestTier,
        getCurrentTierSummaries: () => currentTierSummaries[currentCheapestTier] || {}
    };
})();